<template>
	<a-layout class="admin-layout">
		<a-layout-header class="admin-header-wrapper">
      <div class="admin-header-content">
        <div class="logo"><img :src="filePreview(logoId)"/></div>
        <a-menu
            class="menu"
            theme="dark"
            mode="horizontal"
            :default-selected-keys="[this.$route.matched[1].name]"
            :style="{ lineHeight: '60px' }"
        >
          <a-menu-item v-show="false" @click="handleMenuClick" key="AdminHome"><img :src="require('@/assets/admin/icon-home.svg')" />首页</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="ContactsAdminIndex"><img :src="require('@/assets/admin/icon-addresss.png')" />通讯录</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="AppCenter"><img :src="require('@/assets/admin/icon-applys.png')" />应用中心</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="CompanyAdminView"><img style="vertical-align: -2px" :src="require('@/assets/admin/icon-company.png')" />我的单位</a-menu-item>
        </a-menu>
        <a-dropdown>
          <div class="avatar-admin">
            <abs-avatar :url="$store.getters.userInfo.avatar" :name="$store.getters.name"/>
            {{ $store.getters.name }}<a-icon type="caret-down" />
          </div>
          <a-menu slot="overlay" class="admin-user-dropdown">
            <a-menu-item key="1" @click="handleLogoutClick">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
		</a-layout-header>
		<a-layout-content :style="{ padding: '24px'}" class="admin-body-wrapper">
			<div class="admin-body-content">
				<router-view/>
			</div>
		</a-layout-content>
<!--		<a-layout-footer :style="{ textAlign: 'center' }">-->
<!--			Ant Design ©2018 Created by Ant UED-->
<!--		</a-layout-footer>-->
	</a-layout>
</template>

<script>

import {getCompanySetting} from "@/api/config";
import AbsAvatar from "@/components/ambition/AbsAvatar.vue";
export default {
	name: "AdminLayout",
  components: { AbsAvatar },
	data() {
		return {
			name: undefined,
			logoId: undefined,
		};
	},
	methods: {
		handleLogoutClick() {
			this.$confirm({
				title: '提示',
				content: '真的要注销登录吗 ?',
				okText: '确定',
				cancelText: '取消',
				onOk: () => {
					this.$store.dispatch('Logout').then(() => {
						location.reload()
					})
				},
				onCancel () {
				}
			})
		},
		getCompanySetting() {
			getCompanySetting().then(res => {
				if (res.success) {
					this.name = res.data['company_name'];
					this.logoId = res.data['company_logo'];
				}
			})
		},
		handleMenuClick({key}) {
			this.$router.push({name: key})
		}
	},
	created() {
		this.getCompanySetting()
	}
}
</script>

<style scoped lang="less">
.admin-layout {
  height: 100vh;
  background: #e8e9eb;
  min-width: 1024px;
	.admin-header-wrapper {
    height: 60px;
    line-height: 60px;
    background-color: #3e7dff;
    box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.1);
    padding: 0 20px;
    .admin-header-content {
      display: flex;
      flex-direction: row;
      max-width: 1366px;
      margin: 0 auto;
    }
    .logo {
      margin-right: 60px;
      padding: 10px 0;
      height: 60px;
      img {
        height: 40px;
        vertical-align: top;
      }
    }
    .avatar-admin {
      color: white;
      cursor: pointer;
      .avatar {
        margin-right: 12px;
        width: 40px;
        display: inline-block;
        /deep/.avatar-name {
          background: #fff;
          color: #3e7dff;
        }
      }
      .anticon {
        margin-left: 12px;
      }
    }
	}
	.menu {
		display: flex;
		flex: 1;
    background-color: #3e7dff;
    font-size: 16px;
    .ant-menu-item{
      margin-right: 35px;
      img {
        vertical-align: -3px;
        margin-right: 8px;
      }
    }
    .ant-menu-item-selected {
      background: rgba(255,255,255,.15);
    }
	}
  .admin-body-wrapper {
    overflow: auto;
    flex: 1;
    .admin-body-content {
      background: #fff;
      border-radius: 6px;
      max-width: 1366px;
      min-height: 100%;
      margin: 0 auto;
      display: flex;
      overflow: hidden;
    }
  }
}

</style>
